(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cards-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(el) {
      if (el.swiper || typeof Swiper === 'undefined') return;
      var arrows = el.closest('.cards-carousel').querySelector('.cards-carousel-arrows');
      new Swiper(el, {
        // 342px card + 8px gap within a 390px viewport with a 24px offset leaves a 16px peek of the next card.
        slidesPerView: 1.137,
        spaceBetween: 8,
        slidesOffsetBefore: 24,
        slidesOffsetAfter: 24,
        grabCursor: true,
        watchOverflow: true,
        // thresholdDelta ignores the small sideways drift of a trackpad while scrolling the page vertically.
        mousewheel: { forceToAxis: true, thresholdDelta: 10 },
        navigation: {
          prevEl: arrows.querySelector('.swiper-button-prev'),
          nextEl: arrows.querySelector('.swiper-button-next')
        },
        breakpoints: {
          992: { slidesPerView: 4, spaceBetween: 16, slidesOffsetBefore: 0, slidesOffsetAfter: 0 }
        },
        // Swiper's double-brace placeholders are split up so they are not read as Liquid.
        a11y: {
          containerRoleDescriptionMessage: el.dataset.carouselLabel,
          itemRoleDescriptionMessage: el.dataset.slideLabel,
          slideLabelMessage: el.dataset.slidePosition.replace('[index]', '{' + '{index}}').replace('[total]', '{' + '{slidesLength}}')
        }
      });
    }

    function boot(scope) {
      Array.prototype.forEach.call((scope || document).querySelectorAll('.cards-carousel-slider'), init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { boot(); });
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
    document.addEventListener('shopify:section:unload', function (event) {
      Array.prototype.forEach.call(event.target.querySelectorAll('.cards-carousel-slider'), function (el) {
        if (el.swiper) el.swiper.destroy(true, true);
      });
    });
    // Bring the selected card into view in the theme editor.
    document.addEventListener('shopify:block:select', function (event) {
      var el = event.target.closest && event.target.closest('.cards-carousel-slider');
      if (el && el.swiper) el.swiper.slideTo(el.swiper.slides.indexOf(event.target));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["categories"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener("DOMContentLoaded", (event) => {
        const slider = document.querySelector('.categories-slider.swiper');
        if(!slider) return;
        
        const isMobileSlider = slider.dataset.mobileSlider === 'true';
        const isDesktopSlider = slider.dataset.desktopSlider === 'true';
        let swiper = null;
        
        function initSlider() {
            const isMobile = window.innerWidth < 992;
            const shouldInit = (isMobile && isMobileSlider) || isDesktopSlider;
            
            if (shouldInit && !swiper) {
                swiper = new Swiper(slider, {
                    slidesPerView: "auto",
                    loop: false,
                    freeMode: true,
                    keyboard: {
                        enabled: true,
                        onlyInViewport: true,
                    },
                    spaceBetween: isMobile ? 12 : 24,
                });
            } else if (!shouldInit && swiper) {
                swiper.destroy(true, true);
                swiper = null;
            }
        }
        
        initSlider();
        window.addEventListener('resize', initSlider);
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-section"]) return;
  try {
    
  function media_view(){
    let session_val = sessionStorage.getItem("col-view");
    if(session_val != null){
      if(session_val == 'product'){
        var pro_grid_filter_wrap = document.querySelector('.pro-grid-filter a');
        pro_grid_filter_wrap.setAttribute('data-id','model');
        pro_grid_filter_wrap.textContent = 'model';
        pro_grid_filter_wrap.closest('.coll-media-view').querySelector('.pro-grid-filter-btn').setAttribute('data-id',session_val);
        pro_grid_filter_wrap.closest('.coll-media-view').querySelector('.pro-grid-filter-btn .pro-grid-filter-value').textContent = session_val;
      }
    }
  }
  // document.addEventListener("DOMContentLoaded", (event) => {
  //   // console.log("dom");
  //   // document.getElementById('collection-grid').classList.remove('init-loading');
  //   document.querySelectorAll('.product-item.init-loading-item').forEach(item_load => {
  //     item_load.classList.remove('init-loading-item');
  //   });
  // });
  document.addEventListener("readystatechange", (event) => {
    // console.log("readystatechange");
    media_view();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["laundry-icons-guide"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function activate(root, id) {
      Array.prototype.forEach.call(root.querySelectorAll('[data-lig-panel]'), function (panel) {
        panel.hidden = panel.dataset.ligPanel !== id;
      });
      Array.prototype.forEach.call(root.querySelectorAll('[data-lig-tab]'), function (button) {
        var active = button.dataset.ligTab === id;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active);
        if (!active) return;
        var label = root.querySelector('[data-lig-dropdown-label]');
        if (label) label.textContent = button.textContent.trim();
      });
    }

    function closeDropdowns(scope) {
      Array.prototype.forEach.call((scope || document).querySelectorAll('[data-lig-dropdown].active'), function (dropdown) {
        dropdown.classList.remove('active');
        dropdown.querySelector('[data-lig-dropdown-toggle]').setAttribute('aria-expanded', 'false');
      });
    }

    document.addEventListener('click', function (event) {
      if (!event.target.closest) return;
      var toggle = event.target.closest('[data-lig-dropdown-toggle]');
      if (toggle) {
        var dropdown = toggle.closest('[data-lig-dropdown]');
        var open = !dropdown.classList.contains('active');
        closeDropdowns();
        dropdown.classList.toggle('active', open);
        toggle.setAttribute('aria-expanded', open);
        return;
      }
      closeDropdowns();
      var tab = event.target.closest('[data-lig-tab]');
      if (tab) activate(tab.closest('[data-lig]'), tab.dataset.ligTab);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeDropdowns();
    });

    // Open the tab that holds the block being edited in the theme editor.
    document.addEventListener('shopify:block:select', function (event) {
      if (!event.target.closest) return;
      var root = event.target.closest('[data-lig]');
      var panel = event.target.closest('[data-lig-panel]');
      if (root && panel) activate(root, panel.dataset.ligPanel);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["loyalty-accordion"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // accordion.js toggles .active but does not touch ARIA, so mirror it onto the trigger.
    function sync(wrap) {
      var button = wrap.querySelector('.accordian-title');
      if (button) button.setAttribute('aria-expanded', wrap.classList.contains('active') ? 'true' : 'false');
    }

    function boot(scope) {
      var target = scope && scope.querySelectorAll ? scope : document;
      Array.prototype.forEach.call(target.querySelectorAll('.loyalty-accordion .accordian-wrap'), function (wrap) {
        if (wrap.laccBound) return;
        wrap.laccBound = true;
        sync(wrap);
        new MutationObserver(function () { sync(wrap); }).observe(wrap, { attributes: true, attributeFilter: ['class'] });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { boot(); });
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["loyalty-tiers"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var ENABLED = 'lion-tier-benefits-compare__benefit-status--enabled';

    function tierOf(cell) {
      var match = cell.className.match(/--tier-(\d+)/);
      return match ? match[1] : null;
    }

    function isEnabled(cell) {
      return !!cell && cell.classList.contains(ENABLED);
    }

    function init(root) {
      var table = root.querySelector('.lion-tier-benefits-compare table');
      // The app renders asynchronously, and re-renders when the login state changes.
      if (!table || root.ltTable === table) return;
      root.ltTable = table;

      var rows = Array.prototype.slice.call(table.querySelectorAll('.lion-tier-benefits-compare__row'));
      if (!rows.length) return;

      var headerCells = Array.prototype.slice.call(
        table.querySelectorAll('.lion-tier-compare__header-cell[class*="--tier-"]')
      );
      var select = root.querySelector('[data-loyalty-tiers-select]');
      var selectWrap = root.querySelector('[data-loyalty-tiers-select-wrap]');
      var toggle = root.querySelector('[data-loyalty-tiers-toggle]');

      function setTier(tier) {
        root.setAttribute('data-active-tier', tier);
        rows.forEach(function (row) {
          var active = null;
          Array.prototype.forEach.call(
            row.querySelectorAll('.lion-tier-benefits-compare__benefit-status'),
            function (cell) {
              var matches = tierOf(cell) === tier;
              cell.classList.toggle('loyalty-tiers-cell--active', matches);
              if (matches) active = cell;
            }
          );
          row.setAttribute('data-lt-active-enabled', isEnabled(active) ? 'true' : 'false');
        });
      }

      // Desktop shows every column, so its muting always follows the entry level tier.
      rows.forEach(function (row) {
        var first = row.querySelector('.lion-tier-benefits-compare__row-cell--tier-0');
        row.setAttribute('data-lt-base-enabled', isEnabled(first) ? 'true' : 'false');
      });

      var previous = select ? select.value : null;
      if (select && headerCells.length) {
        select.innerHTML = '';
        headerCells.forEach(function (cell) {
          var tier = tierOf(cell);
          if (tier === null) return;
          var option = document.createElement('option');
          option.value = tier;
          option.textContent = (cell.textContent || '').trim();
          select.appendChild(option);
        });
        if (previous && select.querySelector('option[value="' + previous + '"]')) select.value = previous;
        selectWrap.hidden = false;
        select.onchange = function () { setTier(select.value); };
      }

      setTier(select && select.value ? select.value : '0');

      var visible = parseInt(root.getAttribute('data-visible-rows'), 10);
      if (!visible || visible < 1) visible = rows.length;
      if (!toggle || rows.length <= visible) {
        if (toggle) toggle.hidden = true;
        return;
      }

      var label = toggle.querySelector('[data-loyalty-tiers-toggle-label]');
      var collapsed = true;
      function apply() {
        rows.forEach(function (row, index) {
          row.classList.toggle('loyalty-tiers-row--hidden', collapsed && index >= visible);
        });
        label.textContent = collapsed ? toggle.getAttribute('data-label-more') : toggle.getAttribute('data-label-less');
        toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      }
      toggle.hidden = false;
      toggle.onclick = function () { collapsed = !collapsed; apply(); };
      apply();
    }

    function observe(root) {
      if (root.ltObserved) return;
      root.ltObserved = true;
      init(root);
      new MutationObserver(function () { init(root); }).observe(root, { childList: true, subtree: true });
    }

    function boot(scope) {
      var target = scope && scope.querySelectorAll ? scope : document;
      Array.prototype.forEach.call(target.querySelectorAll('[data-loyalty-tiers]'), observe);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { boot(); });
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(el) {
      if (el.swiper || typeof Swiper === 'undefined') return;
      new Swiper(el, {
        slidesPerView: 'auto',
        // 342px slide + 8px gap within a 390px viewport with a 24px offset leaves a 16px peek of the next slide.
        spaceBetween: 8,
        slidesOffsetBefore: 24,
        slidesOffsetAfter: 24,
        grabCursor: true,
        watchOverflow: true,
        breakpoints: {
          992: { spaceBetween: 24, slidesOffsetBefore: 120, slidesOffsetAfter: 120 }
        },
        // Swiper's double-brace placeholders are split up so they are not read as Liquid.
        a11y: {
          containerRoleDescriptionMessage: el.dataset.carouselLabel,
          itemRoleDescriptionMessage: el.dataset.slideLabel,
          slideLabelMessage: el.dataset.slidePosition.replace('[index]', '{' + '{index}}').replace('[total]', '{' + '{slidesLength}}')
        }
      });
    }

    function boot(scope) {
      Array.prototype.forEach.call((scope || document).querySelectorAll('.media-carousel-slider'), init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { boot(); });
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
    document.addEventListener('shopify:section:unload', function (event) {
      Array.prototype.forEach.call(event.target.querySelectorAll('.media-carousel-slider'), function (el) {
        if (el.swiper) el.swiper.destroy(true, true);
      });
    });
    // Bring the selected slide into view in the theme editor.
    document.addEventListener('shopify:block:select', function (event) {
      var el = event.target.closest && event.target.closest('.media-carousel-slider');
      if (el && el.swiper) el.swiper.slideTo(el.swiper.slides.indexOf(event.target));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }    		
              var productslider=[];
              document.querySelectorAll('.product-carousel').forEach(function(Element,index){    
                let productid = Element.dataset.id;
                let outer_carousel = Element.closest('.carousel-rowouter');
                let nextbutton = outer_carousel.querySelectorAll('.swiper-button-next')[0];
                let prevbutton = outer_carousel.querySelectorAll('.swiper-button-prev')[0];
                let swiperObject={
                  loop:eval(Element.dataset.loop),
                  slidesPerView: "auto",
                  navigation: {
                    nextEl:nextbutton,
                    prevEl:prevbutton,
                  },
                };    
                productslider[productid]=new Swiper(Element,swiperObject);
              }); 
              if(typeof quickAddButton == 'function'){
              quickAddButton();
              }
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
